import { ExtendedTheme } from "@/core/components/Theme";
import { FOOTER_LINKS } from "@/core/data";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { Box } from "@mui/material";

const styles = (theme: ExtendedTheme) => ({
  root: {
    zIndex: 2,
    width: "100%",
    height: "100px",
    backgroundColor: theme.palette.layout.background,
    color: theme.palette.layout.color,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "8px 0",
    "& p": {
      marginBottom: theme.spacing(1),
    },
    "& a": {
      marginRight: theme.spacing(2),
      display: "inline-flex",
      "&:last-child": {
        marginRight: 0,
      },
    },
  },
});

const Footer = () => {
  const classes: any = useCustomStyles(styles);
  const footerLinks: string[] = FOOTER_LINKS;
  // const initializationConfig = useContext(ConfigContext);

  return (
    <Box sx={classes?.root}>
      <p>{t("common.footer.title")}</p>
      <div>
        {footerLinks?.map((link, index) => {
          return (
            <a key={index} href={t(`common.footer.${link}.url`)} target="blank">
              {t(`common.footer.${link}.link`)}
            </a>
          );
        })}
      </div>

      {/*{initializationConfig && initializationConfig.legalArea === LegalArea.MIE && (*/}
      {/*  <LanguageToggleButton />*/}
      {/*)}*/}
    </Box>
  );
};

export default Footer;
